<footer>

    <div class="footer-grid">

        <div class="footer-brand">

            <a routerLink="/" class="logo"></a>

            <p>
                Premium sportswear za klubove, škole i sportske organizacije.
            </p>

        </div>

        <div>

            <h3>NAVIGACIJA</h3>

            <a routerLink="/">Početna</a>
            <a routerLink="/catalog">Katalog</a>
            <a routerLink="/gallery">Galerija</a>
            <a routerLink="/contact">Kontakt</a>

        </div>
        <div class="contact-info">

            <h3>Kontakt</h3>

            <p>
                📍
                <span>ILIJE GOJKOVIĆA 9 </span>
                <span>Požarevac, Srbija </span>
            </p>

            <p>
                📞                
                  <span> +381 69 132 3911</span>
              
            </p>

            <p>
                📞             
                <span> +381 62 218 400</span>
         
            </p>

                    <p>
                <span class="email-text">
                    ✉ lazzarosportskaoprema@gmail.com
                </span>
            </p>

        </div>

        <div>

            <h3>Pratite nas</h3>

            <div class="socials">

                <a href="https://www.instagram.com/lazzaro_sportwear?stkn=aHZ5NWNhMW5rZmRy"><i class="fa-brands fa-instagram"></i></a>
                <a href="#"><i class="fa-brands fa-facebook-f"></i></a>

            </div>

        </div>

    </div>

<div class="copyright">
    © 2026 Lazzaro Sportswear. Sva prava zadržana.
    <br>
    Designed by Nica Studio & Developed by
    <a href="mailto:socialmilos87@gmail.com">MJSolutions</a>
</div>

</footer>